"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const MAX_WIDTH = 120;
const ORIGINAL_WIDTH = 120;
const ORIGINAL_HEIGHT = 20;
const BreadcrumbSkeletonWrapper = styled_components_1.default.div({
    display: 'flex',
    width: '100%',
    maxWidth: MAX_WIDTH,
});
// @todo add delimiter content `/` as :after or :before pseudo el
const BreadcrumbDelimiter = styled_components_1.default.div(({ theme: { space } }) => ({
    display: 'inline',
    margin: `0 ${space[2]}`,
}));
const BreadcrumbSkeleton = props => {
    const { className, itemCount = 1, delimiter = '/' } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, Array.from({ length: itemCount }, (__, i) => (react_1.default.createElement(react_1.default.Fragment, { key: i },
        react_1.default.createElement(BreadcrumbSkeletonWrapper, { className: className },
            react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { height: ORIGINAL_HEIGHT, width: ORIGINAL_WIDTH, uid: `breadcrumbSkeleton-${i}`, style: { height: '100%', width: '100%' } },
                react_1.default.createElement("rect", { x: "0", y: "0", rx: "2", ry: "2", width: ORIGINAL_WIDTH, height: ORIGINAL_HEIGHT }))),
        i !== itemCount - 1 && (react_1.default.createElement(BreadcrumbDelimiter, null, delimiter)))))));
};
exports.default = BreadcrumbSkeleton;
//# sourceMappingURL=Breadcrumb.skeleton.js.map